export default __webpack_public_path__ + "static/media/FlatGenericCAFullSize.b7d7f80c.png";